/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

$(".hamburger").click(function(){
  $(this).toggleClass("is-active");
  $('.infracore-inside').toggleClass("is-active");
  $(".nav-primary").animate({
      //width: "toggle",
      opacity: "toggle"
  }, 300);
});

$(".search-icon").click(function(event){
  event.preventDefault();
  $(".search-form-wrapper").addClass("is-active");
  $(".search-form-container .form-control").focus();
});

$(".search-close-icon, .search-form-overlay").click(function(event){
  event.preventDefault();
  $(".search-form-wrapper").removeClass("is-active");
});


$(window).scroll(function() {    
    var scroll = $(window).scrollTop();

     //>=, not <=
    if (scroll >= 30) {
        //clearHeader, not clearheader - caps H
        $(".banner").addClass("shadow-scroll");
    } else {
        $(".banner").removeClass("shadow-scroll");
    }
});

$('.slider-default').slick({
  nextArrow: '<span class="btn btn-square slick-arrow arrow-right"><i class="fas fa-angle-right"></i></span>',
  prevArrow: '<span class="btn btn-square slick-arrow arrow-left"><i class="fas fa-angle-left"></i></span>',
  dots: true,
  speed: 600,
});

$('.slider-hero').slick({
  nextArrow: '<span class="btn btn-square slick-arrow arrow-right"><i class="fas fa-angle-right"></i></span>',
  prevArrow: '<span class="btn btn-square slick-arrow arrow-left"><i class="fas fa-angle-left"></i></span>',
  autoplay: true,
  autoplaySpeed: 3500,
  dots: false,
  arrows: true,
  speed: 300,
  fade: true,
  pauseOnHover: false,
});

$('.slider-projecten').each(function( index ) {
  $(this).attr('projecten-slider', index);


  $('.slider', this).slick({
    nextArrow: '<li><span class="btn btn-secondary btn-square"><i class="fas fa-chevron-right"></i></span></li>',
    prevArrow: '<li><span class="btn btn-secondary btn-square"><i class="fas fa-chevron-left"></i></span></li>',
    speed: 600,
    slidesToShow: 3,
    appendArrows: '[projecten-slider="' + index + '"] .btn-list ul',
    dots: false,
    //mobileFirst: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
});

$('.slider-referenties').each(function( index ) {
  $(this).attr('referenties-slider', index);

  $('.slider', this).slick({
    speed: 600,
    appendDots: '[referenties-slider="' + index + '"] .slider-referenties-dots',
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3500,
  });
});




  function checkAcceptedValues(value, array) {
    var isAcceptedValue = false;
    if(value === 'select'){
      return false;
    }
    for (var i = 0; i < array.length; i++) {
      if(array[i] === value){
        isAcceptedValue = true;
      }
    }
    return isAcceptedValue;
  }

  $('.bridge-combinations').change(function(e){
    var acceptedValues = $(e.target).find('option:selected').data('combinations'),
      $widthSelector = $('#bridge-width'),
      $lengthSelector = $('#bridge-length'),
      isWidthSelector = $(e.target).is('#bridge-width');

    acceptedValues = acceptedValues.split(',');

    if(isWidthSelector) {
      $lengthSelector.find('option').removeAttr('disabled');
      $lengthSelector.find('option').each(function(){
        if(!checkAcceptedValues($(this).val(),acceptedValues)){
          $(this).attr('disabled',true);
        }
      });

    }else {
      $widthSelector.find('option').removeAttr('disabled');
      $widthSelector.find('option').each(function(){
        if(!checkAcceptedValues($(this).val(),acceptedValues)){
          $(this).attr('disabled',true);
        }
      });

    }
  });

  if($('.bridge-combinations').length){
    $('.bridge-combinations').trigger('change');
  }

  $('.set-bridge-url').on('change',function(){
    var defaultHref = '/bridge-configurator/',
        newHref = defaultHref + '?';

    $('.set-bridge-url').each(function(){
      var name = $(this).attr('id').replace('bridge-',''),
          val  = $(this).val();
      newHref += name + '=' + val + '&';
    });

    $('a[href*="/bridge-configurator/"]').attr('href', newHref);

  });


  





AOS.init({
  offset: 99, // offset (in px) from the original trigger point
  duration: 800, // values from 0 to 3000, with step 50ms
  easing: 'easeInOutQuad', // default easing for AOS animations
  once: true,
});

    /**
     * Retrieve posts
     */
    function get_posts($params) {

      $container = $('#container-async');
      $content   = $container.find('.content');
      $status    = $container.find('.status');

      $status.text('Loading posts ...');
      $content.toggleClass('loading');

      $.ajax({
                  url: bobz.ajax_url,
                  data: {
                    action: 'do_filter_posts',
          nonce: bobz.nonce,
          params: $params
                  },
                  type: 'post',
                  dataType: 'json',
                  success: function(data, textStatus, XMLHttpRequest) {
                
                    if (data.status === 200) {
                      $content.html(data.content);
                    }
                    else if (data.status === 201) {
                      $content.html(data.message);  
                    }
                    else {
                      $status.html(data.message);
                    }
               },
               error: function(MLHttpRequest, textStatus, errorThrown) {

          $status.html(textStatus);
          
          /*console.log(MLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);*/
               },
        complete: function(data, textStatus) {
          
          msg = textStatus;

                if (textStatus === 'success') {
                  msg = data.responseJSON.found;
                }

                $status.text('Posts found: ' + msg);
                $content.toggleClass('loading');
                
                /*console.log(data);
                console.log(textStatus);*/
              }
          });
    }

    /**
     * Bind get_posts to tag cloud and navigation
     */
    $('#container-async').on('click', 'a[data-filter], .pagination a', function(event) {
      if(event.preventDefault) { event.preventDefault(); }

      $this = $(this);

      

      /**
       * Set filter active
       */
      if ($this.data('filter')) {
        $('.nav-filter .active').removeClass('active');
        $this.parent('li').addClass('active');
        $page = $this.data('page');
      }
      else {
        /**
         * Pagination
         */
        $page = parseInt($this.attr('href').replace(/\D/g,''));
        $this = $('.nav-filter .active a');
        $('html,body').animate({scrollTop: $("#container-async").parents('.section').offset().top - $(".banner").outerHeight() }, 500);
      }
      

          $params    = {
            'page' : $page,
            'tax'  : $this.data('filter'),
            'term' : $this.data('term'),
            'qty'  : $this.closest('#container-async').data('paged'),
          };

          // Run query
          get_posts($params);
        
    });
    
    $('a[data-term="all-terms"]').trigger('click');

$('.dropdown-menu a.dropdown-toggle').on('click', function(e) {
  if (!$(this).next().hasClass('show')) {
    $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
  }
  var $subMenu = $(this).next(".dropdown-menu");
  $subMenu.toggleClass('show');


  $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function(e) {
    $('.dropdown-submenu .show').removeClass("show");
  });


  return false;
});

$('.gallery-item').magnificPopup({
  type: 'image',
  gallery:{
    enabled:true
  }
});

$('.sf-input-select').addClass('custom-select');
        
$('#qr-code').on('click',function(){
  var text = 'https://infracoregolfbridges.com/bridge-configurator/?';

  text += 'length='+($('#brug-configuratie-length').val() / 1000) +'&';
  text += 'width='+($('#brug-configuratie-width').val() / 1000) +'&';
  text += 'texture='+encodeURIComponent($('#brug-configuratie-texture').val())+'&';
  text += 'color='+encodeURIComponent($('#brug-configuratie-color').val())+'&';
  text += 'railing='+encodeURIComponent(($('#brug-configuratie-railing').val() !== 'None' ? $('#brug-configuratie-railing').val() : '0' ) );
  $("#qr-code-block").html("");
  new QRCode(document.getElementById("qr-code-block"), text);
  $(".qr-code-container").css('display','flex');
});

$('.qr-code-container:after, .qr-code-close').on('click',function(){
  $(".qr-code-container").css('display','none');
});


      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
